import { useState, useEffect } from 'react'
import "./style.css";
import ChatModal from '../../../Components/ChatModal/ChatModal';
import SendInvite from './modals/sendInvite/SendInvite';
import DateSchedule from './modals/dateSchedule/DateSchedule';
import TimeSchedule from './modals/timeSchedule/TimeSchedule';
import SessionCategory from './modals/session/SessionCategory';
import CalendarSchedule from './modals/calendarSchedule/CalendarSchedule';
import AddToCalendar from './modals/addToCalendar/AddToCalendar';
import AdditionalCoachingHours from './modals/coachingPlan/AdditionalCoachingHours';
import MobilePopUp from '../../../Components/MobilePopUp/MobilePopUp';
import toast from 'react-hot-toast';
import { rescheduleSession, scheduleSession } from '../../../Services/coaching';
import GroupMemberSelectionModal from './modals/session/GroupMemberSelectionModal';

const SessionSelection = ({ onClose, showLiveSessionModal, setShowLiveSessionModal, isReschedule=false, sessionId=null, setShowCalendar, initialPage = 'choice'}) => {
    const [selectedSession, setSelectedSession] = useState('private');
    const [page,setPage] = useState(initialPage);
    const [startTime, setStartTime] = useState(new Date().toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase());
    const [endTime, setEndTime] = useState(new Date(Date.now() + 15 * 60000).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase());    
    const [hoursCount, setHoursCount] = useState(0);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [error, setError] = useState('');
    const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
    const [partnerId, setPartnerId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
 
    useEffect(() => {
      const handleResize = () => {
        setScreenWidth(window.innerWidth);
      };
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

    const handleSessionSchedule = async () => {
        setLoading(true);
        try {
            const [time, period] = startTime.split(' ');
            const [hours, minutes] = time.split(':');
    
            let hour = parseInt(hours);
            if (period.toLowerCase() === 'pm' && hour !== 12) {
                hour += 12;
            } else if (period.toLowerCase() === 'am' && hour === 12) {
                hour = 0;
            }
    
            const year = selectedDate.getFullYear();
            const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
            const day = selectedDate.getDate().toString().padStart(2, '0');
            const dateStr = `${year}-${month}-${day}`;
    
            const formattedDateTime = `${dateStr}T${hour.toString().padStart(2, '0')}:${minutes}:00`;

            const payload = isReschedule ? {
                session_id: sessionId,
                scheduled_on: formattedDateTime,
                type: selectedSession
            } : {
                scheduled_on: formattedDateTime,
                type: selectedSession
            };

            const response = isReschedule ? await rescheduleSession(payload) : await scheduleSession(payload);
            
            if(response.message === "Network Error") {
                setError('Server is not responding. Please try again later');
                return;
            }

            // isReschedule && setShowCalendar(false);
            setSuccessMessage(isReschedule ? 'Session rescheduled successfully' : 'Session scheduled successfully');
            setPage('schedule');
            
        } catch (error) {
            setError('Something went wrong. Please try again later');
        } finally {
            setLoading(false);
        }
    }
    
  return (
    <>
        {page === 'choice' && (
            <>
                {screenWidth > 480 ? (
                    <ChatModal 
                        isOpen={showLiveSessionModal}
                        onClose={() => setShowLiveSessionModal(false)}
                        children={
                            <SessionCategory
                                onClose={onClose}
                                setPage={setPage}
                                selectedSession={selectedSession}
                                setSelectedSession={setSelectedSession}
                                isReschedule={isReschedule}
                                setIsGroupModalOpen={setIsGroupModalOpen}
                            />
                        }
                        height={'fit-content'}
                        width={'476px'}
                    />
                ) : (
                    <MobilePopUp 
                        isPopupVisible={showLiveSessionModal}
                        onClose={() => setShowLiveSessionModal(false)}
                        children={
                            <SessionCategory
                                onClose={onClose}
                                setPage={setPage}
                                selectedSession={selectedSession}
                                setSelectedSession={setSelectedSession}
                                hideCloseIcon={true}
                                isReschedule={isReschedule}
                                setIsGroupModalOpen={setIsGroupModalOpen}
                            />
                        }
                        hideClose={false}
                    />
                )}
            </>
        )}

        {page === 'date' && 
            <>
                {screenWidth > 480 ? (
                    <ChatModal
                        isOpen={showLiveSessionModal}
                        onClose={() => setShowLiveSessionModal(false)}
                        children={
                            <DateSchedule
                                onClose={onClose} 
                                setPage={setPage} 
                                selectedDate={selectedDate} 
                                setSelectedDate={setSelectedDate} 
                            />
                        }
                        height={'fit-content'}
                        width={'476px'}
                    />
                ) : (
                    <MobilePopUp
                        isPopupVisible={showLiveSessionModal}
                        onClose={() => setShowLiveSessionModal(false)}
                        children={
                            <DateSchedule
                                onClose={onClose} 
                                setPage={setPage} 
                                selectedDate={selectedDate} 
                                setSelectedDate={setSelectedDate} 
                            />
                        }
                        hideClose={true}
                    />
                )}
            </>
        }

        {page === 'time' && 
            <> 
                {screenWidth > 480 ? (
                    <ChatModal 
                        isOpen={showLiveSessionModal}
                        onClose={() => setShowLiveSessionModal(false)}
                        children={
                            <TimeSchedule
                                onClose={onClose}
                                setPage={setPage}
                                startTime={startTime}
                                setStartTime={setStartTime}
                                endTime={endTime}
                                setEndTime={setEndTime}
                                selectedDate={selectedDate}
                                selectedSession={selectedSession}
                                handleSessionSchedule={handleSessionSchedule}
                                loading={loading}
                                error={error}
                            />
                        }
                        height={'fit-content'}
                        width={'476px'}
                    />
                ) : (
                    <MobilePopUp
                        isPopupVisible={showLiveSessionModal}
                        onClose={() => setShowLiveSessionModal(false)}
                        children={
                            <TimeSchedule
                                onClose={onClose}
                                setPage={setPage}
                                startTime={startTime}
                                setStartTime={setStartTime}
                                endTime={endTime}
                                setEndTime={setEndTime}
                                selectedDate={selectedDate}
                                selectedSession={selectedSession}
                                handleSessionSchedule={handleSessionSchedule}
                                loading={loading}
                                error={error}
                            />
                        }
                        hideClose={true}
                    />
                )}
            </>
        }

        {page === 'schedule' && 
            <>
                {screenWidth > 480 ? (
                        <ChatModal 
                            isOpen={showLiveSessionModal}
                            onClose={() => setShowLiveSessionModal(false)}
                            children={
                                <CalendarSchedule
                                    onClose={onClose}
                                    setPage={setPage}
                                    selectedDate={selectedDate}
                                    startTime={startTime}
                                    endTime={endTime}
                                    isReschedule={isReschedule}
                                    handleDone={() => {
                                        setShowLiveSessionModal(false)
                                        toast.success(successMessage)
                                    }}
                                />
                            }
                            height={'fit-content'}
                            width={'476px'}
                        />
                    ) : (
                        <MobilePopUp 
                            isPopupVisible={showLiveSessionModal}
                            onClose={() => setShowLiveSessionModal(false)}
                            children={
                                <CalendarSchedule
                                    onClose={onClose}
                                    setPage={setPage}
                                    selectedDate={selectedDate}
                                    startTime={startTime}
                                    endTime={endTime}
                                    hideCloseIcon={true}
                                    isReschedule={isReschedule}
                                    handleDone={() => {
                                        setShowLiveSessionModal(false)
                                        toast.success(successMessage)
                                    }}
                                />
                            }
                            hideClose={false}
                        />
                    )
                }
            </> 
        }

        {page === 'coachingPlan' &&
            <>
                {screenWidth > 480 ? 
                    (
                        <ChatModal 
                            isOpen={showLiveSessionModal}
                            onClose={() => setShowLiveSessionModal(false)}
                            children={
                                <AdditionalCoachingHours
                                    onClose={onClose}
                                    hoursCount={hoursCount}
                                    setHoursCount={setHoursCount}
                                />
                            }
                            height={'fit-content'}
                            width={'476px'}
                        />
                    ) : (
                        <MobilePopUp 
                            isPopupVisible={showLiveSessionModal}
                            onClose={() => setShowLiveSessionModal(false)}
                            children={
                                <AdditionalCoachingHours
                                    onClose={onClose}
                                    hoursCount={hoursCount}
                                    setHoursCount={setHoursCount}
                                    hideCloseIcon={true}
                                />
                            }
                            hideClose={false}
                        />
                    )
                }
            </>
        }
           
        {page === 'addToCalendar' && 
            <>
                {screenWidth > 480 ? (
                    <ChatModal 
                        isOpen={showLiveSessionModal}
                        onClose={() => setShowLiveSessionModal(false)}
                        children={
                            <AddToCalendar 
                                onClose={onClose} 
                                setPage={setPage} 
                                selectedSession={selectedSession}
                            />
                        }
                        height={'fit-content'}
                        width={'476px'}
                    />
                ) : (
                    <MobilePopUp 
                        isPopupVisible={showLiveSessionModal}
                        onClose={() => setShowLiveSessionModal(false)}
                        children={
                            <AddToCalendar 
                                onClose={onClose} 
                                setPage={setPage} 
                                hideCloseIcon={true} 
                                selectedSession={selectedSession}
                            />
                        }
                        hideClose={false}
                    />
                )}
            </>
        }

        {page === 'sendInvite' &&
            <>
                {screenWidth > 480 ? (
                    <ChatModal
                        isOpen={showLiveSessionModal}
                        onClose={() => setShowLiveSessionModal(false)}
                        children={
                            <SendInvite 
                                onClose={onClose} 
                                setPage={setPage} 
                                setPartnerID={setPartnerId} 
                                handleInvite={handleSessionSchedule}
                                loading={loading}
                            />
                        }
                        height={'602px'}
                        width={'812px'}
                    />
                ) : (
                    <MobilePopUp
                        isPopupVisible={showLiveSessionModal}
                        onClose={() => setShowLiveSessionModal(false)}
                        children={
                            <SendInvite 
                                onClose={onClose} 
                                setPage={setPage} 
                                hideCloseIcon={true} 
                                setPartnerID={setPartnerId} 
                                handleInvite={handleSessionSchedule}
                                loading={loading}
                            />
                        }
                        hideClose={false}
                    />
                )}
            </>
        }
        {isGroupModalOpen && (
            <>
                {screenWidth > 480 ? (
                    <ChatModal
                        isOpen={isGroupModalOpen}
                        onClose={() => setIsGroupModalOpen(false)}
                        children={
                            <GroupMemberSelectionModal
                                onClose={() => setIsGroupModalOpen(false)}
                                hideCloseIcon={false}
                            />
                        }
                        height={'fit-content'}
                        width={'476px'}
                    />
                    ) : (
                        <MobilePopUp
                            isPopupVisible={isGroupModalOpen}
                            onClose={() => setIsGroupModalOpen(false)}
                            children={
                                <GroupMemberSelectionModal
                                    onClose={() => setIsGroupModalOpen(false)}
                                    hideCloseIcon={true}
                                />
                            }
                            hideClose={false}
                        />
                    )
                }
            </>
        )}
    </>
  )
}

export default SessionSelection